var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19178_2787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91352 5.02496L10.3002 7.41829H0.853516V8.75163H10.3002L7.90685 11.145L8.85352 12.085L12.8535 8.08496L8.85352 4.08496L7.91352 5.02496ZM13.5202 4.08496V12.085H14.8535V4.08496H13.5202Z",
    fill: "#64748D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19178_2787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.187012 0.0849609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpNext);
export default __webpack_public_path__ + "static/media/upNext.f63bffbce7c63b9612fcec580902844e.svg";
export { ForwardRef as ReactComponent };